/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FlagTriangleLeft = [
  "svg",
  defaultAttributes,
  [["path", { d: "M17 22V2L7 7l10 5" }]]
];

export { FlagTriangleLeft as default };
//# sourceMappingURL=flag-triangle-left.js.map
